import { useMemo } from 'react';
import type { JiraUserBoardNavigationData } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/jsw-userboard-sidebar-navigation/types.tsx';
import { useJiraUserBoardNavigationResource } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/jsw-user-board-navigation-resource/index.tsx';
import type { UseAvatarReturn, Avatar } from './types.tsx';

const extractData = (navData: JiraUserBoardNavigationData): Avatar | null => ({
	name: navData.owner.name,
	url: navData.owner.avatarUrl,
});

export const useAvatar = (): UseAvatarReturn => {
	const { data, loading, error } = useJiraUserBoardNavigationResource();
	const extractedData = useMemo(() => (data ? extractData(data) : null), [data]);
	return { data: extractedData, loading, error };
};
